<template>
  <div class="rt-advance-table-group">
    <el-checkbox
      v-if="showCheckAll"
      :indeterminate="isIndeterminate"
      v-model="checkAll"
      class="rt-check-all"
      @change="handleCheckAllChange"
    >
      {{ $tx('全选', 'xpc.advancetable.checkall') }}
    </el-checkbox>
    <el-checkbox-group
      v-bind="$attrs"
      v-model="selectValue"
      :class="classes"
      @change="handelChange"
    >
      <slot>
        <rt-advance-table-item
          v-for="(item, index) in labelList"
          :label="item[valueKey]"
          :key="index"
          >{{ item[nameKey] }}
        </rt-advance-table-item>
      </slot>
    </el-checkbox-group>
    <div v-if="showCollapse" class="rt-advance-table-group-collapse">
      <div v-if="packUp" class="more-item" @click="packUpItems">
        <p>{{ this.$tx('收起全部', 'xpc.advancetable.hiddenall') }}</p>
        <rt-icon name="rt-base-arrow_up"></rt-icon>
      </div>
      <div v-else class="more-item" @click="rollUpItems">
        <p>{{ this.$tx('展开更多', 'xpc.advancetable.more') }}</p>
        <rt-icon name="rt-base-arrow_down"></rt-icon>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RtAdvanceTableGroup',
  provide() {
    return {
      col: this.col
    };
  },
  props: {
    value: Array,
    labelList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    alias: {
      type: Object,
      default: () => {
        return {
          valueKey: 'value',
          nameKey: 'name'
        };
      }
    },
    vertical: {
      type: Boolean,
      default: false
    },
    showCheckAll: {
      type: Boolean,
      default: false
    },
    showCollapse: {
      type: Boolean,
      default: false
    },
    col: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      selectValue: this.value,
      isIndeterminate: true,
      checkAll: false,
      packUp: false
    };
  },
  computed: {
    valueKey() {
      return this.alias.valueKey;
    },
    nameKey() {
      return this.alias.nameKey;
    },
    classes() {
      return [
        'rt-checkbox-group',
        {
          'rt-checkbox-group-vertical': this.vertical
        }
      ];
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.selectValue = newVal;
    }
  },
  methods: {
    handelChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.labelList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.labelList.length;
      this.$emit('input', value);
    },
    handleCheckAllChange(value) {
      let allValue = [];
      this.labelList.forEach(item => {
        allValue.push(item.value);
      });
      this.selectValue = value ? allValue : [];
      this.isIndeterminate = false;
      this.$emit('input', this.selectValue);
    },
    packUpItems() {
      this.$emit('pack-up');
      this.packUp = false;
    },
    rollUpItems() {
      this.$emit('roll-up');
      this.packUp = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtAdvanceTableGroup.vue?9ed0263e